// extracted by mini-css-extract-plugin
export default {"exam_list_selectors":"ExamList_exam_list_selectors__8OAtZ"};